import { Component } from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'kng-modal',
  templateUrl: './kng-modal.component.html',
  styleUrls: []
})
export class KngModalComponent {
  type;
  title;
  contents;
  button;

  constructor(public activeModal: NgbActiveModal) { }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/layout/kingswell/kng-modal/kng-modal.component.ts